import { FieldProps, TemplatedTextAreaFieldSchema } from '../types/Form';
import { TemplatedInput as TemplatedInputComponent } from 'common/ui/TemplatedInput';

export const TemplatedInput: React.FC<
  FieldProps<TemplatedTextAreaFieldSchema>
> = ({ name, value, field, errorMessage, onChange, onBlur }) => {
  const {
    label,
    subLabel,
    availableVariables,
    minHeight,
    charactersCountLimit
  } = field;
  return (
    <TemplatedInputComponent
      name={name}
      value={value}
      charactersCountLimit={charactersCountLimit}
      field={{
        label,
        subLabel,
        availableVariables
      }}
      minHeight={minHeight}
      errorMessage={errorMessage}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};
